/**
 * English translations for property requests page.
 * Used by individuals tracking their listing requests through Safaqat24's FAL licence.
 */

const propertyRequests = {
  // Page header
  title: 'My Property Requests',
  subtitle: 'Track the status of your property listing requests',
  newRequest: 'New Request',

  // Status labels
  status: {
    draft: 'Draft',
    pending: 'Pending Review',
    approved: 'Approved',
    rejected: 'Rejected',
    listed: 'Listed',
    completed: 'Completed',
  },

  // Listing type
  listingType: {
    sale: 'For Sale',
    rent: 'For Rent',
  },

  // Request details
  description: 'Description',
  expectedPrice: 'Expected Price',
  contact: 'Contact Information',
  specifications: 'Specifications',
  bedrooms: 'Bedrooms',
  bathrooms: 'Bathrooms',
  sqm: 'sqm',
  sar: 'SAR',
  negotiable: 'Negotiable',

  // Timeline
  submitted: 'Submitted',
  reviewed: 'Reviewed',
  rejectionReason: 'Rejection Reason',

  // Actions
  viewListing: 'View Listing',
  contactToEdit: 'Contact us to make changes',

  // Empty state
  empty: {
    title: 'No requests yet',
    description:
      'Submit a property listing request and track its status here. Your property will be listed under Safaqat24\'s FAL licence.',
    cta: 'Submit Request',
  },

  // Info box
  info: 'Once approved, your property will be listed under Safaqat24\'s license. You\'ll receive a notification when your listing is live.',

  // Error states
  error: {
    notLoggedIn: 'Please log in to view your requests',
    loadFailed: 'Failed to load your requests. Please try again.',
    retry: 'Retry',
  },
};

export default propertyRequests;
